import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { TemplateLayout } from '../../../types/badge.type'
import { BADGE_TYPES } from '../../../enums/badge.enum'
import { CommonModule } from '@angular/common'
import { BadgeTemplateCreationComponent } from '../badge-template-creation/badge-template-creation.component'
import { BadgeTemplateSelectionComponent } from '../badge-template-selection/badge-template-selection.component'

@Component({
  selector: 'app-badge-area',
  templateUrl: './badge-area.component.html',
  styleUrls: ['./badge-area.component.scss'],
  standalone: true,
  imports: [CommonModule, BadgeTemplateCreationComponent, BadgeTemplateSelectionComponent]
})
export class BadgeAreaComponent {
  @Input() public selectedTemplate!: TemplateLayout | null
  @Input() public badgeForm!: FormGroup
  @Output() public onBadgeSelected: EventEmitter<TemplateLayout> = new EventEmitter<TemplateLayout>()
  @Output() public onCancel: EventEmitter<void> = new EventEmitter<void>()

  public isOrderBadgePopupOpen: boolean = true

  ngOnInit(): void {
    if (this.badgeForm.value?.badge_front_html_content) {
      this.selectedTemplate = {
        height: 0,
        width: 0,
        type: 0
      }
      const parser = new DOMParser()
      const document = parser.parseFromString(this.badgeForm.value.badge_front_html_content, 'text/html')
      const badge = document.getElementById('badge')
      this.selectedTemplate.width = parseInt(badge?.getAttribute('data-width') || '')
      this.selectedTemplate.height = parseInt(badge?.getAttribute('data-height') || '')
      this.selectedTemplate.type = parseInt(badge?.getAttribute('data-badgeType') || '') as BADGE_TYPES
      this.onBadgeSelected.emit(this.selectedTemplate)
    }
  }

  /**
   * @method selectTemplate
   * @description Select the template for the badge
   * @param id number
   * @returns void
   */
  public selectTemplate(badgeData: TemplateLayout): void {
    this.onBadgeSelected.emit(badgeData)
  }
}
